import type { Tone } from '@/types/domain';

export const statusTone: Record<string, Tone> = {
  ACTIVE: 'green', VERIFIED: 'green', APPROVED: 'green', CHECKED: 'green', ACKNOWLEDGED: 'green', SETTLED: 'green', ACCEPTED: 'green', RECEIVED: 'green', PASSED: 'green', POSTED_TO_SAP: 'green', COMPLETED: 'green',
  SUBMITTED: 'blue', IN_PROGRESS: 'blue', SENT: 'blue', SENT_TO_VENDOR: 'blue', UPLOADED: 'blue',
  PENDING_APPROVAL: 'amber', PENDING: 'amber', PARTIALLY_RECEIVED: 'amber', CURRENT: 'amber',
  ON_HOLD: 'orange', RETURNED: 'orange', CHANGES_REQUESTED: 'orange', EXPIRED: 'orange',
  REJECTED: 'red', REJECTED_BY_VENDOR: 'red', FAILED: 'red', MISMATCHED: 'red',
  BLOCKED: 'dark', CANCELLED: 'dark',
  DRAFT: 'grey', NOT_SYNCED: 'grey', NOT_INSPECTED: 'grey', UPCOMING: 'grey',
};

export const humanize = (value: string) => value.toLowerCase().split('_').map((word) => word[0].toUpperCase() + word.slice(1)).join(' ');
